import { formatISO } from 'date-fns';
import { ProfessionalData } from '../life-plan.model';

export interface Employment {
  afiliationStartDate?: string;
  currentOcupationCodes?: string[];
  currentStatus?: string;
  employmentDuration?: string;
}

export function getEmploymentFromProfessionalData(professionalData: ProfessionalData): Employment {
  const employment: Employment = {
    currentStatus: professionalData.employmentRelationship
  };
  if (professionalData.contributionYears) {
    employment.employmentDuration = `P${professionalData.contributionYears}Y`;
  }
  if (professionalData.employment) {
    employment.currentOcupationCodes = [professionalData.employment];
  }
  return employment;
}
